import React from "react";
import { ArrowUpRight } from "lucide-react";

/**
 * Dark vignette only — image en haut + titre + texte en bas.
 */
const VignetteCard = ({
    image,
    title,
    body,
    href,
    badge,
    eyebrow,
    testid,
    aspect = "square",
}) => {
    const aspectClass =
        aspect === "square" ? "aspect-square"
        : aspect === "video" ? "aspect-video"
        : "aspect-[4/5]";

    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={testid}
            className="group block relative vignette-dark cursor-pointer"
        >
            <div className={`relative ${aspectClass} overflow-hidden bg-ink-700`}>
                {image ? (
                    <img
                        src={image}
                        alt={title}
                        className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.06]"
                        loading="lazy"
                    />
                ) : (
                    <div className="absolute inset-0 bg-gradient-to-br from-bronze-deep to-ink-700" />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-ink-900/75 via-transparent to-transparent" />

                {badge && (
                    <span className="absolute top-3 right-3 text-[10px] font-mono-tracked rounded-full px-2.5 py-1 bg-champagne text-ink-900">
                        {badge}
                    </span>
                )}

                {eyebrow && (
                    <span className="absolute top-3 left-3 text-[10px] font-mono-tracked text-champagne">
                        {eyebrow}
                    </span>
                )}
            </div>

            <div className="p-4 md:p-5">
                <div className="flex items-start justify-between gap-3">
                    <h4 className="font-display text-lg md:text-xl text-ivory leading-tight font-light">
                        {title}
                    </h4>
                    <ArrowUpRight className="shrink-0 w-4 h-4 mt-1 transition-transform duration-500 group-hover:rotate-12 group-hover:translate-x-0.5 text-champagne" />
                </div>
                {body && (
                    <p className="mt-2 text-xs md:text-sm leading-snug text-ivory/55">
                        {body}
                    </p>
                )}
            </div>
        </a>
    );
};

export default VignetteCard;
